import { HttpClient } from "../httpClient";

const httpClient = new HttpClient();

const reCaptchaVerify = (token: Object) => {
    return httpClient.post(`Login/verify-bot`, token);
}



const reCaptchaApiService = {
    reCaptchaVerify
};

export default reCaptchaApiService;